export const medicineStripes = Object.freeze({
	SEM_TARJA: 'Sem tarja',
	VERMELHA: 'Vermelha',
	PRETA: 'Preta'
});
